/* eslint no-console:0 */
import 'styles/application';
import 'bootstrap/dist/js/bootstrap.bundle';



// WEBPACK FOOTER //
// app/client/packs/styling-framework.js